
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: 'Section',
    props: {
        section: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        toggleSection: {
            type: Function,
            required: true,
        },
        isExpanded: {
            type: Function,
            required: true,
        },
        isExpandable: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const isSectionExpanded = computed(() => props.isExpanded(props.section));

        const sectionTitle = computed(() => (props.isExpandable ? props.title : `${props.title} (No Data)`));

        const toggleIsExpanded = () => {
            if (props.isExpandable) {
                props.toggleSection(props.section);
            }
        };

        return { isSectionExpanded, sectionTitle, toggleIsExpanded };
    }
});
